import { render, staticRenderFns } from "./LoadingProgressBar.vue?vue&type=template&id=712e04d4&scoped=true&"
import script from "./LoadingProgressBar.vue?vue&type=script&lang=js&"
export * from "./LoadingProgressBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712e04d4",
  null
  
)

export default component.exports